import layout from './CrontabWindow.html?raw';
import Window from '@/Controls/Window';
import ComponentManager from '@/Management/ComponentManager';
import CrontabWindowViewModel from '@/ViewModels/Controls/CrontabWindowViewModel';

export default class CrontabWindow extends Window {

    public constructor(viewModel: CrontabWindowViewModel, element?: JQuery) {
        let $element = element || $('<div>');
        super(viewModel, $element);

        this.applyTemplate(layout, $element);
    }

    public getElementToAppended(): JQuery<HTMLElement> {
        return $('[data-region=Modal]');
    }
}

ComponentManager.setControl('CrontabWindow', CrontabWindow, 'RADPresentation.HTMLClient.DefaultViewExtensions');